export enum LoginType_Enum {
  otp = 0,
  usernamePassword = 1,
}
